module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_ornskoldsvik-57cfe31e42d74abd8c722044e01c804a.png";